'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  HIDDEN: 'jp-hidden'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jplayer-utils/lib/classes.js
// module id = 113
// module chunks = 0